// src/pages/Signup.jsx
import { signInWithGoogle } from "../auth";
import { Link } from "react-router-dom";

export default function Signup() {
  return (
    <div style={{ padding: 16 }}>
      <h2>Sign up</h2>
      <button onClick={signInWithGoogle}>Continue with Google</button> {/* [web:21] */}
      <p>
        Have an account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
}
